import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { App } from "@capacitor/app";
import useHandleResponse from "hooks/useHandleResponse";

const AppUrlListener = () => {
  let history = useHistory();
  let setResponse = useHandleResponse();

  useEffect(() => {
    App.addListener("appUrlOpen", (event) => {
      const domain = event?.url?.split(".id")[0];
      const slug = event?.url?.split(".id")?.pop();
      if (
        domain === "https://talent.ekrutes" &&
        event.url?.includes("tes/kode")
      )
        return history.push(`/performtes?url=${event.url}`);

      setResponse({ status: -1, message: "URL tidak valid", type: "error" });
      return history.push("/");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default AppUrlListener;
